var _script, _script2, _defs, _g, _script3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileArrowBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 445,
    height: 543,
    viewBox: "0 0 445 543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 225,
    width: 445,
    height: 543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 1024,
    height: 768,
    transform: "translate(-0.2 -0.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 835.3,
    height: 765.9,
    transform: "translate(407.4 -1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -27.903,
    y1: -1.765,
    x2: -27.403,
    y2: -1.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77a6d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaecec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.392,
    y1: -2.016,
    x2: -25.892,
    y2: -1.266,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0271b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#0270b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#036aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#05629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#08568a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#0b4670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#0f3350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -24.393,
    y1: -0.016,
    x2: -23.893,
    y2: -0.766,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0271b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#0270b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#036aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#05629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#08568a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0b4670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#0f3350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -42.387,
    y1: 0.975,
    x2: -42.887,
    y2: 1.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77a6d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -42.219,
    y1: -1.443,
    x2: -42.719,
    y2: -0.693,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.75,
    y1: -5.286,
    x2: 0.5,
    y2: -4.536,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11273d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#0f3350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#0b4670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#08568a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#05629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#036aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#0270b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0271b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.75,
    y1: -5.277,
    x2: 0.5,
    y2: -4.527,
    xlinkHref: "#linear-gradient-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_6",
    "data-name": "Scroll Group 6",
    transform: "translate(-579 -225)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tile-arrow-bg2",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    opacity: 0.8,
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 568.3,
    y2: 328,
    transform: "translate(693.6 123.8)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 568.2,
    y2: 328,
    transform: "translate(703.6 141)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 568.2,
    y2: 328,
    transform: "translate(713.5 158.2)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 568.2,
    y2: 328,
    transform: "translate(723.4 175.4)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x1: 568.3,
    y2: 328,
    transform: "translate(733.3 192.6)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x1: 568.2,
    y2: 328,
    transform: "translate(743.3 209.8)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x1: 568.2,
    y2: 328,
    transform: "translate(753.2 227)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 568.3,
    y2: 328,
    transform: "translate(763.1 244.2)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x1: 568.2,
    y2: 328,
    transform: "translate(773.1 261.4)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x1: 568.2,
    y2: 328,
    transform: "translate(783 278.6)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x1: 568.3,
    y2: 328,
    transform: "translate(792.9 295.8)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 568.2,
    y2: 328,
    transform: "translate(802.9 313)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x1: 568.2,
    y2: 328,
    transform: "translate(812.8 330.2)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x1: 568.2,
    y2: 328.1,
    transform: "translate(822.7 347.3)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 568.3,
    y2: 328.1,
    transform: "translate(832.6 364.5)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 568.2,
    y2: 328.1,
    transform: "translate(842.6 381.7)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x1: 568.2,
    y2: 328.1,
    transform: "translate(852.5 398.9)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x1: 568.3,
    y2: 328.1,
    transform: "translate(862.4 416.1)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x1: 568.2,
    y2: 328.1,
    transform: "translate(872.4 433.3)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 568.2,
    y2: 328.1,
    transform: "translate(882.3 450.5)",
    fill: "none",
    stroke: "#0271b8",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.08
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1243.5,640.9l-219.9-127v254Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M803.7,641l220-127V768Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M583.9,514l220-127V641Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M935.7,310.8,803.9,234.7V386.9Z",
    stroke: "#77a6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1243.4,336.1l-87.9-50.8V386.9Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1155.5,285.3l87.9-50.8V336.1Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M1067.6,336l87.9-50.7V386.8Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1155.5,386.8,1067.6,336V437.6Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M979.6,386.8l88-50.8V437.6Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M979.6,488.3l87.9-50.7V539.1Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1067.6,437.6l-88-50.8V488.4Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M891.7,437.6l87.9-50.8V488.4Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1155.5,488.4l-87.9-50.8V539.2Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1067.5,539.2l88-50.8V590Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1243.4,539.2l-87.9-50.8V590Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1155.5,590l87.9-50.8V640.7Z",
    fill: "#0271b8",
    stroke: "#0271b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M759.9,513.8l131.8-76.1V589.9Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.281,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1243.5,767.7V640.9L1024,767.7Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1028.3,770.6,803.7,640.9l.1,130.2Z",
    fill: "#11273d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M803.9,767.7v-127l-220,127Z",
    fill: "url(#linear-gradient-7)"
  }))))), _script3 || (_script3 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileArrowBg3);
export default __webpack_public_path__ + "static/media/tile-arrow-bg3.9af84d57b3f9482b038bdfc74091a8ac.svg";
export { ForwardRef as ReactComponent };